import firebase from "./firebase";
import { firestore as db } from "./firebase";
import { AuthenticatedUser } from "./users";
import { BaseModel } from "./models";
import { Comment } from "./comments";

export const COLLECTION_COMMENT_FLAGS: string = "comment_flags";

// The CommentFlag type defines how the comment flag is saved in the Firestore database.
export type CommentFlag = BaseModel & {
  commentId: string;
  userId: string;
  statementId: string;
};

export async function flagComment(comment: Comment, user: AuthenticatedUser) {
  // Add a new CommentFlag document.
  const document = db.collection(COLLECTION_COMMENT_FLAGS).doc();
  const commentFlag: CommentFlag = {
    id: document.id,
    timestamp: firebase.firestore.Timestamp.now(),
    commentId: comment.id,
    userId: user.id,
    statementId: comment.statement.statementId,
  };
  await document.set(commentFlag);
}

export async function unflagComment(
  commentId: string,
  userId: string,
  isAdmin: boolean
) {
  // Delete the CommentFlag document for the comment/user combination.
  let query = db
    .collection(COLLECTION_COMMENT_FLAGS)
    .where("commentId", "==", commentId);

  // Or, when admin, delete all flags for the comment.
  if (!isAdmin) query = query.where("userId", "==", userId);

  const data = await query.get();

  data.forEach((doc) => doc.ref.delete());
}

// Returns all commentIds of the comments that were flagged by the given user for the given statementId.
export function getCommentsFlaggedByUser(
  statementId: string,
  userId: string,
  setFlags: (flags: string[]) => void
) {
  return db
    .collection(COLLECTION_COMMENT_FLAGS)
    .where("statementId", "==", statementId)
    .where("userId", "==", userId)
    .onSnapshot((snapshot) => {
      let data: CommentFlag[] = [];
      snapshot.forEach((doc) => data.push({ ...doc.data() } as any));
      setFlags(data.map((c) => c.commentId));
    });
}
